import { BaseSyntheticEvent, useEffect } from 'react';
import { useIdentificationFormContext } from '../contexts/IdentificationFormContext';
import { FieldValues, useFormContext } from 'react-hook-form';

interface ISetDirtyModalValues {
  saveValues: (e?: BaseSyntheticEvent) => Promise<void>;
}

export const SetDirtyModalValues = <TValues extends FieldValues>({
  saveValues,
}: ISetDirtyModalValues) => {
  const { setIsFormDirty, setInfoModal, defaultModalInfo } = useIdentificationFormContext();
  const {
    trigger,
    formState: { isDirty },
  } = useFormContext<TValues>();

  useEffect(() => {
    setIsFormDirty(isDirty);
    if (isDirty) {
      const onClose = () => setInfoModal((prev) => ({ ...prev, isOpened: false }));
      setInfoModal((prev) => ({
        ...prev,
        title: 'Зберегти зміни?',
        primaryButtonTitle: 'Зберегти і продовжити',
        secondaryButtonTitle: 'Відхилити та продовжити',
        isDisabledOutsideClickClose: true,
        onPrimaryButtonClick: async (callback) => {
          const isValid = await trigger();

          if (isValid) {
            await saveValues();
            setInfoModal(defaultModalInfo);
            setIsFormDirty(false);
            callback?.();
          } else {
            onClose();
          }
        },
        onSecondaryButtonClick: () => {
          setIsFormDirty(false);
          setInfoModal(defaultModalInfo);
        },
        onClose: onClose,
      }));
    }
  }, [isDirty]);
  return null;
};
